import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom'

const Shop = () => {

    const [minValue, setMinValue] = useState(15);
    const [maxValue, setMaxValue] = useState(500);

    const rangeRef = useRef(null);

    const MIN = 0;
    const MAX = 1000;

    const updateRange = () => {
        if (!rangeRef.current) return;

        let min = minValue;
        let max = maxValue;

        if (min > max) {
            min = max;
            setMinValue(max);
        }

        const percentMin = (min / MAX) * 100;
        const percentMax = (max / MAX) * 100;

        rangeRef.current.style.left = `${percentMin}%`;
        rangeRef.current.style.width = `${percentMax - percentMin}%`;
    };

    useEffect(() => {
        updateRange();
    }, [minValue, maxValue]);

    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Shop</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="shop all-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="price-filter">
                                <h3>Price Filter</h3>
                                <div className="range-slider">
                                    <div className="slider-track" />
                                    <div className="slider-range" ref={rangeRef} />

                                    <input
                                        type="range"
                                        min={MIN}
                                        max={MAX}
                                        value={minValue}
                                        onChange={(e) => setMinValue(Number(e.target.value))}
                                    />
                                    <input
                                        type="range"
                                        min={MIN}
                                        max={MAX}
                                        value={maxValue}
                                        onChange={(e) => setMaxValue(Number(e.target.value))}
                                    />


                                </div>
                                <p className="range-text">
                                    <span>Min: {minValue}</span>
                                    <span>Max: {maxValue}</span>
                                </p>
                            </div>
                            <div className="category-sidebar">
                                <h3 className="sidebar-title">Shop by Category</h3>
                                <ul className="category-list">
                                    <li><Link to="#">All</Link></li>
                                    <li><Link to="#">Dummy Here</Link></li>
                                    <li><Link to="#">Dummy Here</Link></li>
                                    <li><Link to="#">Dummy Here</Link></li>
                                    <li><Link to="#">Dummy Here</Link></li>
                                    <li><Link to="#">Dummy Here</Link></li>
                                    <li><Link to="#">Dummy Here</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="top-filter-bar">
                                <span className="products-found">1500 Products found</span>
                                <div className="filter-options">
                                    <div className="filter-item custom-select">
                                        <label htmlFor="sort">Sort by:</label>
                                        <select id="sort">
                                            <option>Default</option>
                                            <option>Newest</option>
                                            <option>Price: Low to High</option>
                                            <option>Price: High to Low</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="show-prg-num d-flex align-items-center">
                                    <p>Show:</p>
                                    <div>
                                        <Link to className="active">6</Link>
                                        <Link to className>24</Link>
                                        <Link to className>48</Link>
                                        <Link to className>60</Link>
                                        <Link to className>90</Link>
                                    </div>
                                </div>
                                <div className="product-count-view">
                                    <div className="view-toggle">
                                        <span className="view-label">View:</span>
                                        <Link to="#" className="view-link active" title="Grid view">
                                            <i className="fas fa-th-large" />
                                        </Link>
                                        <Link to="#" className="view-link " title="Grid view">
                                            <i className="fas fa-th-large" />
                                        </Link>
                                        <Link to="#" className="view-link" title="List view">
                                            <i className="fas fa-list" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="row pt-4">
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-1.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-2.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-3.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-4.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-6.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-7.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-8.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-9.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="seller_cards">
                                        <Link to="/cart" className="iconabt">
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
                                        </Link>
                                        <div className="seller_img">
                                            <img src="images/seller-10.jpg" alt />
                                        </div>
                                        <div className="seller_txt">
                                            <h4><Link to="/shop-detail">Product Name Here</Link></h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed </p>
                                            <div className="s_txt_flx">
                                                <span>
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    (4.5k)
                                                </span>
                                            </div>
                                            <div className="slr_prc">
                                                <h3>From $36.49</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Shop